import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { MediaComponent } from '@shared/components/media/media.component';
import { DeviceService } from '@shared/tools/device.service';
import { CarouselModule } from 'primeng/carousel';
import { CmsBannerResponse } from '@core/models/atomics.model';
import { DEVICE_SIZE } from '@core/models/deviceSize.model';
import { CX_ABSTRACT_COMPONENT_DATA } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';
import { LinkComponent } from '@shared/components/link/link.component';

@Component({
  selector: 'cx-banner-carousel',
  templateUrl: './cx-banner-carousel.component.html',
  styleUrls: ['./cx-banner-carousel.component.scss'],
  imports: [CommonModule, CarouselModule, MediaComponent, LinkComponent],
})
export class CxBannerCarouselComponent {
  protected readonly data = inject<CmsBannerResponse>(CX_ABSTRACT_COMPONENT_DATA);
  protected readonly deviceService = inject(DeviceService);

  mediaContainers = computed(() => this.data.banners || []);

  autoplayInterval = computed(() => this.data.sleep || 5000);

  showIndicators = computed(
    () => this.deviceService.isScreenSizeAtLeast(DEVICE_SIZE.DESKTOP) && this.mediaContainers().length > 1,
  );
}
